import Modal from './Modal.jsx';

export default function ConfirmDialog({
  open,
  title = 'Confirmar exclusío',
  message,
  confirmLabel = 'Excluir',
  cancelLabel = 'Cancelar',
  busy = false,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal open={open} onClose={onCancel} maxWidth="max-w-md">
      <div className="text-center">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-error-container/50 text-error">
          <span className="material-symbols-outlined text-[24px]">delete</span>
        </div>
        <h2 className="studio-uniform-title mt-4 text-on-surface">{title}</h2>
        {message && <p className="mt-2 text-[11px] leading-6 text-on-surface-variant">{message}</p>}
        <div className="mt-6 flex justify-center gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="rounded-2xl border border-surface-container-high px-5 py-3 text-[11px] font-semibold text-on-surface disabled:opacity-40"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className="rounded-2xl bg-error px-5 py-3 text-[11px] font-semibold text-white shadow-[0_12px_24px_rgba(220,38,38,0.25)] disabled:opacity-40"
          >
            {busy ? 'Excluindo...' : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}